import { Fragment, ReactNode } from "react";
import { CreateApiKeyFunction, CreateApiKeyParams } from "./types";
import { api } from "~/utils/api";
import { User } from "~/modules/user/store/types";
import { ApiKey } from "../../types";

// // // //

interface ChildProps {
    createApiKey: CreateApiKeyFunction;
    error: boolean;
    loading: boolean;
}

// TODO - annotate this
export function ApiKeyCreator(props: {
    user: User;
    children: (childProps: ChildProps) => ReactNode;
}) {
    // Fetch items via tRPC
    const createMutation = api.apiKeys.create.useMutation();

    // Set loading + error state
    const loading = createMutation.isLoading || false;
    const error = createMutation.error !== undefined;

    async function createApiKey(
        params: CreateApiKeyParams,
    ): Promise<ApiKey | null> {
        return createMutation.mutateAsync({
            name: params.name,
            organizationID: props.user.organization.id,
        });
    }

    return (
        <Fragment>
            {props.children({
                error,
                loading,
                createApiKey,
            })}
        </Fragment>
    );
}
